
export enum RoleEnum {
    OWNER = 1,
    ADMIN = 2,
    CREATOR = 3,
    SUPPORT = 4,
    USER = 5
}